import { render, staticRenderFns } from "./RegionsManagement.vue?vue&type=template&id=50579618&scoped=true"
import script from "./RegionsManagement.vue?vue&type=script&lang=js"
export * from "./RegionsManagement.vue?vue&type=script&lang=js"
import style0 from "./RegionsManagement.vue?vue&type=style&index=0&id=50579618&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50579618",
  null
  
)

export default component.exports